import { Button, Card, Col, Form, Input, Row } from "antd";
import React, { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import useApi from "../helpers/useApi";
import { API_METHODS } from "../helpers/constant";
import { isEmpty } from "../helpers/generalFunctions";

function Login() {
  const [response, request] = useApi("/login", null, API_METHODS.POST);
  const [form] = Form.useForm();
  const navigate = useNavigate();
  const LoginClicked = () => {
    form.validateFields().then((values) => {
      values.role = "admin";
      request(values, API_METHODS.POST, `/admin/login`);
    });
  };

  useEffect(() => {
    if (!isEmpty(response) && !isEmpty(response.data) && !response.isLoading) {
      if (response.data.authToken) {
        console.log(response);
        localStorage.setItem("authToken", response.data.authToken);
        localStorage.setItem("user", JSON.stringify(response.data.user));
        navigate("/portal/dashboard");
      }
    }
  }, [response]);

  return (
    <>
      <Row
        type="flex"
        justify="center"
        align="middle"
        style={{ minHeight: "100vh" }}
      >
        <Col xs={20} sm={16} md={12} lg={10} xl={8}>
          <Card title={"Login"}>
            <Form layout="vertical" onFinish={LoginClicked} form={form}>
              <Form.Item
                label="Username"
                name="username"
                rules={[
                  { required: true, message: "Please input your username!" },
                  { max: 20 },
                ]}
              >
                <Input />
              </Form.Item>
              <Form.Item
                label="Password"
                name="password"
                rules={[
                  { required: true, message: "Please input your password!" },
                  { max: 15 },
                ]}
              >
                <Input.Password />
              </Form.Item>
              <Form.Item>
                <Button
                  type="primary"
                  htmlType="submit"
                  style={{ float: "right" }}
                >
                  Submit
                </Button>
              </Form.Item>
            </Form>
          </Card>
        </Col>
      </Row>
    </>
  );
}

export default Login;
